// extracted by mini-css-extract-plugin
export default {"record-activity-modal__paper":"RecordActivityModal_record-activity-modal__paper__JSyB7","record-activity-modal__content":"RecordActivityModal_record-activity-modal__content__mqZ08"};